module.exports = __webpack_public_path__ + "static/Ola-033a245ad77b408b8b14d9c3318ea332.mp4";